(function () {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

  const menuToggle = $('[data-menu-toggle]');
  const mobileMenu = $('[data-mobile-menu]');
  const menuClose = $('[data-menu-close]');
  const setMobileMenu = (open) => {
    if (!mobileMenu) return;
    mobileMenu.hidden = !open;
    document.body.classList.toggle('menu-open', open);
    if (menuToggle) menuToggle.setAttribute('aria-expanded', String(open));
  };
  if (menuToggle) menuToggle.addEventListener('click', () => setMobileMenu(true));
  if (menuClose) menuClose.addEventListener('click', () => setMobileMenu(false));

  const megaToggle = $('[data-mega-toggle]');
  const megaMenu = $('[data-mega-menu]');
  if (megaToggle && megaMenu) {
    megaToggle.addEventListener('click', () => {
      const open = megaMenu.hidden;
      megaMenu.hidden = !open;
      megaToggle.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', (event) => {
      if (!megaMenu.hidden && !event.target.closest('[data-site-header]')) {
        megaMenu.hidden = true;
        megaToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  $$('[data-quantity-selector]').forEach((selector) => {
    const input = $('input[type="number"]', selector);
    $('[data-quantity-minus]', selector)?.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    $('[data-quantity-plus]', selector)?.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  $$('[data-product-media-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const image = $('img', button);
      if (!image) return;
      const overlay = document.createElement('div');
      overlay.className = 'product-media-lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', image.alt || 'Product image');
      const clone = image.cloneNode();
      clone.removeAttribute('srcset');
      clone.removeAttribute('sizes');
      overlay.appendChild(clone);
      overlay.addEventListener('click', () => overlay.remove());
      document.body.appendChild(overlay);
    });
  });

  $$('[data-bundle-selector]').forEach((selector) => {
    const property = $('[data-bundle-property]', selector.closest('form'));
    $$('[data-bundle-option]', selector).forEach((input) => {
      input.addEventListener('change', () => {
        $$('.bundle-card', selector).forEach((card) => card.classList.toggle('is-selected', card.contains(input)));
        if (property) property.value = input.dataset.bundleLabel || `Buy ${input.value}`;
      });
    });
  });

  $$('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const basePrice = Number(option?.dataset.price || 0);
      const container = select.closest('.product-info');
      if (!container || !basePrice) return;
      const currency = window.Shopify?.currency?.active || 'USD';
      const money = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
      $$('[data-bundle-card]', container).forEach((card) => {
        const quantity = Number(card.dataset.quantity || 1);
        const discount = Number(card.dataset.discount || 0);
        const full = basePrice * quantity;
        const discounted = Math.round(full * (100 - discount) / 100);
        const priceNode = $('[data-bundle-price]', card);
        const fullNode = $('[data-bundle-full]', card);
        if (priceNode) priceNode.textContent = money(discounted);
        if (fullNode) fullNode.textContent = money(full);
      });
    });
  });

  $$('[data-card-gallery]').forEach((gallery) => {
    const images = $$('[data-card-image]', gallery);
    const dots = $$('.collection-card__dots i', gallery);
    if (images.length < 2) return;
    let activeIndex = 0;
    const showImage = (nextIndex) => {
      activeIndex = (nextIndex + images.length) % images.length;
      images.forEach((image, index) => image.classList.toggle('is-active', index === activeIndex));
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
    };
    $('[data-card-prev]', gallery)?.addEventListener('click', () => showImage(activeIndex - 1));
    $('[data-card-next]', gallery)?.addEventListener('click', () => showImage(activeIndex + 1));
    showImage(0);
  });

  $$('[data-video-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const src = button.dataset.videoSrc;
      if (!src) return;
      const overlay = document.createElement('div');
      overlay.className = 'wellness-video-modal';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', button.dataset.videoTitle || 'Wellness video');

      const dialog = document.createElement('div');
      dialog.className = 'wellness-video-modal__dialog';
      const closeButton = document.createElement('button');
      closeButton.className = 'wellness-video-modal__close';
      closeButton.type = 'button';
      closeButton.setAttribute('aria-label', 'Close video');
      closeButton.textContent = '×';
      const video = document.createElement('video');
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.preload = 'metadata';
      video.src = src;

      const closeVideo = () => {
        video.pause();
        overlay.remove();
        document.body.classList.remove('video-open');
      };
      closeButton.addEventListener('click', closeVideo);
      overlay.addEventListener('click', (event) => {
        if (event.target === overlay) closeVideo();
      });
      dialog.append(closeButton, video);
      overlay.appendChild(dialog);
      document.body.appendChild(overlay);
      document.body.classList.add('video-open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      $('.product-media-lightbox')?.remove();
      const videoModal = $('.wellness-video-modal');
      if (videoModal) {
        $('video', videoModal)?.pause();
        videoModal.remove();
        document.body.classList.remove('video-open');
      }
    }
  });

  $$('.home-products__tabs button').forEach((tab) => {
    tab.addEventListener('click', () => {
      $$('.home-products__tabs button').forEach((button) => {
        const active = button === tab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      const category = tab.dataset.productTab;
      if (category) {
        $$('[data-product-category]').forEach((card) => {
          card.hidden = card.dataset.productCategory !== category;
        });
        const carousel = $('.product-carousel');
        carousel?.classList.toggle('is-bundles', category === 'bundles');
      }
    });
  });

  const filterDrawer = $('[data-filter-drawer]');
  $('[data-filter-toggle]')?.addEventListener('click', () => {
    filterDrawer?.classList.add('is-open');
    document.body.classList.add('menu-open');
  });
  $('[data-filter-close]')?.addEventListener('click', () => {
    filterDrawer?.classList.remove('is-open');
    document.body.classList.remove('menu-open');
  });
  $('[data-sort-select]')?.addEventListener('change', (event) => event.target.form.submit());

  const updateCartCount = async () => {
    try {
      const cart = await fetch('/cart.js').then((response) => response.json());
      const count = $('.header-cart span');
      if (count) count.textContent = cart.item_count;
    } catch (_) {}
  };

  $$('.quick-add').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = $('button[type="submit"]', form);
      if (!button || button.disabled) return;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'ADDING…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Unable to add item');
        button.textContent = 'ADDED ✓';
        await updateCartCount();
      } catch (_) {
        form.submit();
        return;
      }
      window.setTimeout(() => {
        button.textContent = original;
        button.disabled = false;
      }, 1600);
    });
  });

  $$('[data-facts-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const image = $('img', button);
      if (!image) return;
      const overlay = document.createElement('div');
      overlay.style.cssText = 'position:fixed;z-index:9999;inset:0;background:rgba(16,35,44,.88);display:grid;place-items:center;padding:22px;cursor:zoom-out';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-label', 'Supplement Facts');
      const clone = image.cloneNode();
      clone.style.cssText = 'max-width:min(760px,94vw);max-height:92vh;background:#fff;object-fit:contain';
      overlay.appendChild(clone);
      overlay.addEventListener('click', () => overlay.remove());
      document.body.appendChild(overlay);
    });
  });
})();
